import Http from "@/api/http";

export default {
  indexDoneFlow(filter) {
    return Http.get(`/done_flows`, {
      params: {
        // solution_id: localStorage.getItem("solution_id"),
        ...filter,
      },
    });
  },

  showDoneFlow(id) {
    return Http.get(`/done_flows/${id}`);
  },

  getDoneFlowPDF(id){
    // return http.get("/done_forms/"+id+".pdf", { responseType: 'blob' })
    return Http.get("/done_flows/"+id+".pdf", { responseType: 'blob' })
  },

  createDoneFlow(flow) {
    return Http.post(`/done_flows`, {flow: {...flow}});
  },

  updateDoneFlow(flow) {
    return Http.put(`/done_flows/${flow.id}`, {flow: {...flow}});
  },

  interruptDoneFlow(done_flow) {
    return Http.put(`/done_flows/${done_flow.id}/interrupt`, {done_flow: {...done_flow}});
  },

  duplicateDoneFlow(flow) {
    return Http.post(`/done_flows/duplicate`, {flow: {...flow}});
  },

  reorderGroups(flow) {
    return Http.put(`/done_flows/${flow.id}/reorder_groups`, {flow: {...flow}});
  },




  indexGroup(filter, flow_id) {
    return Http.get(`/done_flows/${flow_id}/groups`, {
      params: {
        // solution_id: localStorage.getItem("solution_id"),
        ...filter,
      },
    });
  },

  showGroup(id) {
    return Http.get(`/groups/${id}`);
  },

  createGroup(group) {
    return Http.post(`/groups`, {group: {...group}});
  },

  updateGroup(group) {
    return Http.put(`/groups/${group.id}`, {group: {...group}});
  },
  deleteGroup(group_id) {
    return Http.delete(`/groups/${group_id}`);
  },







  indexStepByFlow(filter, flow_id) {
    return Http.get(`/flows/${flow_id}/steps`, {
      params: {
        // solution_id: localStorage.getItem("solution_id"),
        ...filter,
      },
    });
  },

  showStep(id) {
    return Http.get(`/steps/${id}`);
  },

  createStep(step) {
    return Http.post(`/steps`, {step: {...step}});
  },

  updateStep(step) {
    return Http.put(`/steps/${step.id}`, {step: {...step}});
  },
};
